import { jsx as c, jsxs as E, Fragment as S } from "react/jsx-runtime";
import { useFoundation as I, focusTrapFactory as M, triggerWindowResize as k, createComponent as u, useClassNames as w, Tag as f, mergeRefs as A } from "@rmwc/base";
import { MDCDismissibleDrawerFoundation as P, MDCModalDrawerFoundation as p } from "@material/drawer";
import { useRef as x, useEffect as N, useCallback as h } from "react";
const R = (o) => function(r) {
  const t = x(), { foundation: s, ...l } = I({
    props: r,
    elements: {
      rootEl: !0,
      scrimEl: !0
    },
    foundation: ({ rootEl: a, emit: y, getProps: z }) => {
      let F;
      return new o({
        //This delayes adding the class until next animation frame, fixes issue with draw getting stuck in open state
        addClass: (n) => window.requestAnimationFrame(() => a.addClass(n)),
        removeClass: (n) => a.removeClass(n),
        hasClass: (n) => a.hasClass(n),
        elementHasClass: (n, m) => n.classList.contains(m),
        saveFocus: () => {
          F = document.activeElement;
        },
        restoreFocus: () => {
          var n;
          (n = a == null ? void 0 : a.ref) != null && n.contains(document.activeElement) && F && F.focus();
        },
        focusActiveNavigationItem: () => {
          var m;
          const n = (m = a.ref) == null ? void 0 : m.querySelector(
            ".mdc-deprecated-list-item--activated"
          );
          n && n.focus();
        },
        notifyClose: () => {
          y(
            "onClose",
            {},
            !0
            /* shouldBubble */
          );
        },
        notifyOpen: () => {
          y(
            "onOpen",
            {},
            !0
            /* shouldBubble */
          );
        },
        trapFocus: () => {
          var n;
          try {
            (n = t.current) == null || n.trapFocus();
          } catch {
          }
        },
        releaseFocus: () => {
          var n;
          try {
            (n = t.current) == null || n.releaseFocus();
          } catch {
          }
        }
      });
    }
  }), { rootEl: i, scrimEl: C } = l;
  N(() => {
    i.ref && (t.current = M(i.ref));
  }, [i.ref]), N(() => {
    r.open ? s.open() : s.close();
  }, [r.open, s]);
  const b = h(() => {
    var a;
    (a = s.handleScrimClick) == null || a.call(s);
  }, [s]), { onKeyDown: D } = r, v = h(
    (a) => {
      D == null || D(a), s.handleKeydown(a);
    },
    [s, D]
  ), { onTransitionEnd: d } = r, T = h(
    (a) => {
      d == null || d(a), s.handleTransitionEnd(a), k();
    },
    [s, d]
  );
  return i.setProp("onKeyDown", v, !0), i.setProp("onTransitionEnd", T, !0), C.setProp("onClick", b, !0), { foundation: s, ...l };
}, H = R(
  P
), O = R(
  p
), J = u(function(e, r) {
  return e.dismissible ? /* @__PURE__ */ c(q, { ...e, ref: r }) : e.modal ? /* @__PURE__ */ c(j, { ...e, ref: r }) : /* @__PURE__ */ c(_, { ...e, ref: r });
}), g = (o) => u(
  function(t, s) {
    const { rootEl: l, scrimEl: i } = o(t), { onOpen: C, onClose: b, open: D, foundationRef: v, ...d } = t;
    return /* @__PURE__ */ E(S, { children: [
      /* @__PURE__ */ c(
        _,
        {
          ref: A(l.reactRef, s),
          ...l.props(d)
        }
      ),
      d.modal && /* @__PURE__ */ c(K, { ...i.props({}) })
    ] });
  }
), j = g(O), q = g(H), _ = u(
  function(e, r) {
    const { dismissible: t, modal: s, foundationRef: l, ...i } = e, C = w(e, [
      "mdc-drawer",
      {
        "mdc-drawer--dismissible": t,
        "mdc-drawer--modal": s
      }
    ]);
    return /* @__PURE__ */ c(f, { tag: "aside", ...i, ref: r, className: C });
  }
), Q = u(
  function(e, r) {
    const t = w(e, ["mdc-drawer__header"]);
    return /* @__PURE__ */ c(f, { ...e, ref: r, className: t });
  }
), U = u(
  function(e, r) {
    const t = w(e, ["mdc-drawer__title"]);
    return /* @__PURE__ */ c(f, { ...e, ref: r, className: t });
  }
), V = u(
  function(e, r) {
    const t = w(e, ["mdc-drawer__subtitle"]);
    return /* @__PURE__ */ c(f, { ...e, ref: r, className: t });
  }
), X = u(
  function(e, r) {
    const t = w(e, ["mdc-drawer__content"]);
    return /* @__PURE__ */ c(f, { ...e, ref: r, className: t });
  }
), K = ({
  onClick: o
}) => /* @__PURE__ */ c("div", { className: "mdc-drawer-scrim", onClick: o }), Y = u(
  function(e, r) {
    const t = w(e, ["mdc-drawer-app-content"]);
    return /* @__PURE__ */ c(f, { ...e, ref: r, className: t });
  }
);
export {
  J as Drawer,
  Y as DrawerAppContent,
  X as DrawerContent,
  Q as DrawerHeader,
  V as DrawerSubtitle,
  U as DrawerTitle
};
